/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'caret-left': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M362.3 465.8L617.1 211c18.9-18.9 34.3-12.6 34.3 14.2V775c0 26.8-15.4 33.1-34.3 14.2L362.3 534.3c-18.9-18.9-18.9-49.6 0-68.5z"/>'
  }
})
